function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P7Info = function P7Info(_ref) {
  var page = _ref.page;
  var thisPage = 3;
  useEffect(function () {
    $('.p7-info').css({
      opacity: page === thisPage ? 1 : 0
    });
  }, [page]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p7-info"
  }, [0, 1, 2, 3, 4, 5].map(function (x) {
    return /*#__PURE__*/React.createElement(Row, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "p7".concat(x)
    });
  }));
};
export default P7Info;
var Row = function Row(_ref2) {
  var nr = _ref2.nr,
    page = _ref2.page,
    thisPage = _ref2.thisPage;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $(".p7-row__a".concat(nr)).addClass("p7-row__a".concat(nr, "--active"));
      }, 3500 + nr * 1000), setTimeout(function () {
        $(".p7-row__".concat(nr)).addClass("p7-row__".concat(nr, "--active"));
      }, 3500 + nr * 1000)]);
    } else {
      $(".p7-row__a".concat(nr)).removeClass("p7-row__a".concat(nr, "--active"));
      $(".p7-row__".concat(nr)).removeClass("p7-row__".concat(nr, "--active"));
    }
  }, [page]);
  var src = {
    0: 'excavation-waste@3x.png',
    1: 'rucar-bs@3x.png',
    2: 'contaminated-fill@3x.png',
    3: 'general-fill@3x.png',
    4: 'vacuum-truck-dredge-waste@3x.png',
    5: 'mixed-loads@3x.png'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/arrow-3@3x.png",
    className: "p7-row__a".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/".concat(src[nr]),
    className: "p7-row__".concat(nr)
  }));
};